export default function videoCard() {
  const widgetName = 'videoCard';
  const widgetOpts = videoCardOpts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'videoCard-container';

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    hasImages: false,
    link: [''],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomVideoCard(data.items[0]);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomVideoCard(widgetData) {
    const { Title, Description } = widgetData;
    const $videoCard = $widget.find('.card-widget-item');

    $videoCard.replaceWith(`
      <h2 class="videoCard-title">${Title}</h2>
      <div class="videoCard-description">${Description}</div>
  `);
  }
}
